export default {
  title: "Торговые точки",
  name: "Название торговой точки",
  namingNoSpecified: "Название не указано",
  tradingPoint: "Торговая точка",
  addressNoSpecified: "Адрес не указан",
  info: "Информация о торговой точке",
  add: {
    title: "Создание торговой точки",
    noOperations: "Не было произведено ни одной операции",
  },
  historyOperation: "История чеков",
  employee: "Сотрудник",
  customer: "Покупатель",
  source: "Источник",
  typeOperation: "Тип операции",
  typeActivity: "Тип деятельности",
  writing: "Списание",
  accrual: "Начисление",
  sumBuy: "Сумма покупки",
  sumWrite: "Сумма списания",
  toPay: "К оплате",
  totalCashback: "Общее вознаграждение",
  salePopup: "Скидка",
  types: {
    balance_up: "Пополнение баланса",
    balance_down: "Списание средств",
    tsp_approve: "Взаиморасчет по чеку",
    balance_refill: "Пополнение баланса",
    tariff_change: "Покупка тарифа",
    cashback_approve: "Клиентское путешествие",
    cashback_charge: "Чек. Списание баллов",
    certificate_charge: "Начисление. Использование подарочной карты",
    certificate_debt: "Списание. Выпуск подарочной карты",
    certificate_refund: "Возврат за выпуск подарочной карты",
    rc_withdraw: "Чек. Прием баллов",
    tsp_commission_fee: "Чек. Комиссия",
    tsp_commission_revert:
      "Доначисление некорректно списанной суммы за период с 1 апреля по дату начисления",
    tsp_commission_correct:
      "Корректировка взаиморасчетов в размере 1% от принятых баллов",
    manual_commission_approve: "Чек. Взаиморасчет по коммиссии",
    manual_withdraw: "Вывод средств",
    cashback_decline: "Отмена чека",
    rc_processing_receipts: "Чек кассового аппарата",
    cashback_approve_decline: "Отмена начисления за клиентское путешествие",
    partner_manual_withdraw: "Списание средств",
    inner_cashback_charge: "Чек. Списание вознаграждения",
    inner_cashback_approve: "Взаиморасчет по чеку",
    tsp_approve_payment: "Чек. Списание средств",
    rc_withdraw_approve: "Чек. Начисление за оплату баллами",
    withdraw_payment: "Чек. Списание средств",
    prodazha_top_mesta: "Покупка топ-места в rcpay",
    reserving_funds_withdrawal: "Зарезервировано к выплате",
    refund_reserved_funds_withdrawal: "Возврат резерва к выплате",
    withdraw_reserved_funds: "Вывод средств",
  },
  organizations: "Юрлицо",
  moderationModalTitle: "Сообщение от модерации",
  clients: "клиенту: ",
  other: "комиссия: ",
  total: "Итого: ",
  draft: "Черновик",
  itsAppearAfterCreateShop: "Они появятся здесь после создания торговой точки",
  inRCPay: {
    published: "Опубликована в RC PAY",
    unpublished: "Не опубликована в RC PAY",
  },
  promotion: "Продвижение",
  openInRCPay: "Открыть в RC PAY",
  couldntSendShopToModeration: "Не удалось сохранить торговую точку",
  shopChangesSuccessSaved: "Изменения данных торговой точки успешно сохранены",
  forLayoultyCreateEmployee:
    "Для работы с программой лояльности необходимо создать кассира в подразделе «Кассиры», закрепив его за данной торговой точкой.",
  changesSendedToModeration:
    "Изменения данных торговой точки отправлены на модерацию",
  someChangesNeedModeration:
    "Некоторые из внесенных изменений требуют модерации",
  changesUpdateAfterModeration:
    "В карточке заведения, отображаемой в RC PAY, они обновятся только после проверки и подтверждения модератором.",
  connectedPaymentMethod: "У торговой точки подключены способы оплаты.",
  ifNeedDeleteConnectWithUs:
    "Если необходимо ее удалить, обратитесь, пожалуйста, в техническую поддержку",
  ifNeedDeleteConnectWithUsSuccess: "Электронная почта скопирована",
  someFieldsUncorrect: "Некоторые поля заполнены некорректно",
  backToEditingToFixIt:
    "Вернитесь к редактированию, чтобы их исправить. Или нажмите «Пропустить», если хотите выйти без сохранения данных в полях с ошибками.",
  wannaQuit: "Хотите выйти?",
  allNotSavedChangesWillRemove:
    "Все изменения, которые не были сохранены, будут утеряны. Чтобы их сохранить, вернитесь назад.",
  cancelCreationPointModal: {
    title: "Отменить создание торговой точки?",
    subtitle:
      "Внесенная информация о торговой точке не сохранится. Чтобы вернуться к редактированию, нажмите «Назад».",
  },
  moderationModal: {
    title: "Торговая точка успешно создана и отправлена на модерацию",
    subtitle:
      "Для работы с программой лояльности необходимо создать кассира в подразделе «Кассиры», закрепив его за данной торговой точкой.",
  },
  deletePromotionModal: {
    title:
      "Точно хотите удалить торговую точку с активной услугой продвижения?",
    subtitle:
      "После удаления оказание услуг продвижения будет прекращено. Денежные средства, оплаченные за продвижение, не будут возвращены. Восстановить данные торговой точки будет невозможно.",
  },
  deleteModal: {
    title: "Точно хотите удалить торговую точку?",
    subtitle: "После удаления восстановить данные будет невозможно.",
    shopDeleted: "Торговая точка удалена",
  },
  lessTariffModal: {
    title: "Вы создали максимальное количество торговых точек на вашем тарифе",
    subtitle:
      "Чтобы создать больше торговых точек, необходимо приобрести другой тариф.",
  },
  validation: {
    specifyMailOrRemoveField: "Укажите адрес эл. почты или удалите поле",
    specifyLinkAddressOrRemove: "Укажите адрес ссылки или удалите поле",
    couldntSendShopToModeration:
      "Не удалось отправить торговую точку на модерацию",
    someImagesCouldntProcess:
      "Некоторые изображения не получилось обработать. Попробуйте загрузить другие",
  },
  creationTab: {
    main: "Основное",
    loyalty: "Программа лояльности",
    addressAndOpeningHours: "Адрес и часы работы",
    contacts: "Контакты",
    foto: "Фото",
  },
  stepFromTo: "Шаг {from} из {total}",
  createShop: "Создать торговую точку",
  createShopAndContinue: "Создать ТТ и продолжить",
  message: {
    dataSavedToDraft: "Данные торговой точки сохранены в черновик",
    fillCorrectSpecifiedFields: "Заполните корректно указанные поля",
    fillCorrectAllRequiredFields: "Заполните корректно все обязательные поля",
  },
  describeYourCompany:
    "Опишите подробно вашу компанию. Пожалуйста, не используйте в тексте хештеги (#) и смайлы. Адреса, контактные данные режим работы указываются отдельно — в следующих вкладках.",
  willDisplayToUserInRCPay: "Будет отображаться у пользователей в RC PAY",
  activityTooltip:
    "Заведение будет отображаться в результатах поиска в RC PAY при фильтрации по выбранным категориям.",
  afterModerationEntityEditingDisable:
    "После подтверждения модерации редактирование юрлица недоступно. Для изменения обратитесь в техническую поддержку.",
  description: "Описание торговой точки",
  charsLimit: {
    min: "Минимум символов - {minChars}",
    max: "Максимум символов - {maxChars}",
  },
  features: "Особенности",
  selectedFeaturesWillDisplayInCard:
    "Выбранные опции будут отображены в карточке вашего заведения в RC PAY в виде тегов",
  catalogTitles: "Название блока с товарами / услугами в RC PAY",
  catalogTitlesTooltip:
    "Общее название для блока с перечнем товаров / услуг торговой точки. Применяется только на странице вашего заведения в RC PAY.",
  totalPercentReward: "Общий процент вонаграждения",
  totalRewardLabel: "Общий % вознаграждения",
  totalPercentRewardValue:
    "Общий процент начисляемого вознаграждения (от 4 до 25).",
  rewardWillPayToClients:
    "Клиентам будет выплачиваться сумма в соответствии со сценариями распределения вознаграждения.",
  checkRewardDistribution: "См. сценарии распределения вознаграждения",
  activeWait: "Задержка начислений",
  activeWaitTooltip:
    "Количество дней (от 0 до 14) с момента совершения клиентом покупки, через которые будет начислено вознаграждение",
  clientDiscount: "Скидка клиентам RC PAY",
  clientDiscountTooltip:
    "Процент скидки (от 0 до 99), которая будет предоставляться клиентам программы лояльности RC GROUP при совершении покупок в торговой точке",
  shopPaylable: "Торговая точка принимает оплату баллами RC",
  shopPaylableDescription:
    "Клиенты, зарегистрированные в RC PAY, смогут оплачивать до 99,9% стоимости покупки баллами RC",
  enteredDataNotNeedModeration:
    "Внесенные данные не требуют модерации и применяются сразу после создания торговой точки или сохранения изменений при ее редактировании (если юрлицо подтверждено).",
  address: "Адрес",
  ifNoYourShopSelectNear:
    "Если на карте нет адреса вашего заведения, выберите ближайший и обратитесь в техническую поддержку для установки корректного адреса",
  startEnteringAddress: "Начните ввод и выберите адрес из списка",
  addressComment: "Комментарий к адресу",
  specifyWayToGetYouShop:
    "Укажите, как пройти к вашему заведению, о необходимости предварительно позвонить или любую другую дополнительную информацию (необязательно)",
  period: {
    workdays: "Будни ПН-ПТ",
    weekend: "Выходные СБ-ВС",
    allDay: "Ежедневно ПН-ВС",
    aroundClock: "Круглосуточно 24/7",
  },
  catalog: "Каталог",
  intervals: "Интервалы",
  weekdays: "Дни недели",
  selectedAllDays: "Выбраны все дни недели",
  workHoursInOtherDays: "Часы работы в другие дни",
  workDays: "Рабочие дни",
  workDaysMobileSubtitle:
    "Выберите интервал или отдельные дни недели, когда торговая точка работает по одному расписанию (часы работы одинаковые для всех выбранных в этом поле дней недели).",
  workDaysTooltips: [
    "Выберите интервал или отдельные дни недели, когда торговая точка работает по одному расписанию (например, Будни ПН-ПТ с 10:00 до 20:00).",
    "Затем нажмите «Часы работы в другие дни» и выберите дни, когда часы работы заведения отличаются (например, СБ с 12:00 до 16:00).",
  ],
  specifyWorkTimeInSelectedDays: "Укажите часы работы в выбранные дни",
  publicTradingPoint: "Опубликовать торговую точку на сайте rcpay.ru",
  publicTTDescription: [
    "Торговая точка будет отображаться на сайте rcpay.ru в списке заведений и в мобильном приложении RC PAY в рамках того города, в котором она находится.",
    "Размещение заведения в RC PAY осуществляется только при условии подтверждения модератором. Для снятия с размещения отключите данную опцию, модерация не требуется.",
  ],
  workOnline: "Торговая точка работает онлайн",
  workOnlineDescription: [
    "Предоставляемые услуги/товары реализуются только удаленно/на доставку.",
    "В поле «Адрес» укажите примерный адрес для размещения торговой точки на карте города – он не будет указан в карточке заведения в RC PAY, вместо него будет отображаться слово «Онлайн».",
  ],
  time: "Часы работы",
  specifyPhoneNumberOrRemove: "Укажите номер телефона или удалите поле",
  specifyMailOrRemove: "Укажите почту или удалите поле",
  onlineService: "Сервис онлайн-записи",
  specifyLinkIfUseOtherServicesForOnline:
    "Укажите здесь ссылку, если используете готовые сервисы для онлайн-записи клиентов",
  linkAddress: "Адрес ссылки",
  addSiteOrSocialMedia: "Добавить ссылки на сайт или соц. сети",
  linkName: "Название ссылки",
  linkNameTooltips: [
    "Укажите, как бы вы хотели, чтобы ссылка отображалась в RC PAY. Например, «Купить» или «Забронировать».",
    "Если ничего не указать, будет отображаться адрес ссылки.",
  ],
  pointPhotos: "Фотографии торговой точки",
  photosRequirements:
    "Должны быть в максимально хорошем качестве, без водяных знаков, надписей и коллажей",
  logo: "Логотип",
  photoRecomendation: "Рекомендации к изображению",
  logoRecomendations: [
    "Файл формата JPEG, JPG, PNG до 10 Мб, соотношение сторон — 1:1",
    "Подойдет логотип, тематическая картинка, изображение с названием или фирменным знаком вашего заведения",
    "Изображение хорошего качества, которое не содержит адрес, телефон и прочую дополнительную информацию",
  ],
  uploadLogo: "Загрузить логотип",
  noClient: "Нет клиента",
  giftCard: "Подарочная карта",
  totalCashbackHints: [
    "В чеке указан общий процент вознаграждения, но сумма в чеке может не совпадать с суммой фактически списанных баллов, отображаемой в строке операции.",
    "Это зависит от того, какой клиент совершил покупку (внутренний или внешний), а также от его тарифа.",
  ],
  previewInRCPay: "Предпросмотр в RC PAY",
  searchByTable: "Поиск по таблице",
  noCheckData: "Данных по чекам нет",

  babySafeSeat: "Детское кресло",
  parking: "Парковка",
  wifi: "WiFi",
  aroundTheClock: "Круглосуточно",
  "16+": "16+",
  noSmoking: "Курение запрещено",
  habitation: "Проживание",
  nutrition: "Питание",
  transfer: "Трансфер",
  excursion: "Экскурсии",
  cardPay: "Оплата картой ",
  foodTakeAway: "Еда на вынос",
  conditioner: "Кондиционер",
  delivery: "Доставка",
  animalsAllow: "Можно с животными",
  dogAllow: "Можно с собакой (ниже 35 см)",
  childrenRoom: "Детская комната",

  assortment: "Ассортимент",
  showcase: "Витрина",
  menu: "Меню",
  portfolio: "Портфолио",
  price: "Прайс",
  products: "Товары",
  productsAndServices: "Товары и услуги",
  services: "Услуги",

  // food
  food: "Еда",
  cafe: "Кафе",
  restaurants: "Рестораны",
  barsClubs: "Бары и клубы",
  fastfood: "Фастфуд",
  coffeeShop: "Кофейни",
  canteens: "Столовые",
  foodDelivery: "Доставка еды и обедов",
  vegetables: "Овощи, фрукты и зелень",
  pizzeria: "Пиццерия",
  goods: "Продукты",
  specials: "Специальное",
  sushiBar: "Суши-бар",
  bakeryProducts: "Выпечка и сладости",
  // shopping
  shopping: "Шопинг",
  clothes: "Одежда",
  shoes: "Обувь",
  accessories: "Аксессуары",
  flowers: "Цветы",
  jewerly: "Ювелирные изделия",
  booksAndCancellery: "Книги и канцтовары",
  zooItems: "Зоотовары",
  // health and beauty
  beautyAndHealth: "Красота и здоровье",
  care: "Уход",
  spa: "Спа",
  medicine: "Медицина",
  pharmacy: "Аптеки",
  cosmeticAndParfume: "Косметика и парфюмерия",
  cosmetology: "Косметология",
  nailStudio: "Ногтевая студия",
  barbershop: "Парикмахерская",
  beautyStudio: "Салон красоты",
  stylistsAndMakeupers: "Визажисты, стилисты",
  // electronic
  technique: "Техника",
  electronic: "Электроника",
  homeAppliances: "Бытовая техника",
  officeEquipment: "Оргтехника",
  communicationSalon: "Салон связи",
  photoTech: "Фототехника",
  // house
  house: "Дом",
  householdGoods: "Хозяйсвенные товары",
  renovation: "Ремонт",
  furniture: "Мебель",
  garden: "Сад и огород",
  decorAndInterior: "Декор и интерьер",
  dishes: "Посуда",
  plumbing: "Сантехника",
  buildingMaterials: "Стройматериалы",
  homeTextile: "Текстиль для дома",
  // for children
  forChildren: "Детям",
  childClothesAndShoes: "Детская одежда и обувь",
  childFood: "Детское питание",
  forMothers: "Для мам",
  toysAndGames: "Игрушки и игры",
  childSections: "Секции для детей",
  // entertaiments
  entertaiments: "Развлечения",
  parks: "Парки",
  cinema: "Кино",
  spaces: "Пространства",
  entertainmentCenter: "Развлекательный центр",
  // sport
  sport: "Спорт",
  clothesAndShoes: "Одежда и обувь",
  turizm: "Туризм",
  sportGym: "Спортзалы",
  swimmingPool: "Бассейн",
  specClothes: "Спец. одежда",
  sportClotheAndShoes: "Спортивная одежда и обувь",
  sportNutrition: "Спортивное питание",
  sportSections: "Спортивные секции",
  sportItems: "Спортивные товары",
  danceStudio: "Студии танцев",
  // hobby
  hobby: "Хобби",
  specShops: "Специализированные магазины",
  studios: "Студии",
  handicraftsAndCreativeProducts: "Товары для рукоделия и творчества",
  // services: "",
  computerHelping: "Компьютерная помощь",
  photoAndVideo: "Фото и видео",
  giftsAndHolidays: "Подарки, праздники",
  leisure: "Досуг",
  repairAndInterior: "Ремонт и интерьеры",
  rentAndRental: "Аренда и прокат",
  traveling: "Путешествия",
  studying: "Обучение",
  atelier: "Ателье",
  autoServices: "Автоуслуги и сервисы",
  householdServices: "Бытовые услуги",
  cargoTransporation: "Грузоперевозки",
  legalServices: "Юридические услуги",
  cleaning: "Клининг",
  consultations: "Консультация",
  supermarkets: "Супермаркеты",
  buildingAndReparir: "Строительство и ремонт",
  // other
  others: "Другое",
  gasStations: "АЗС",
  halal: "Халяль",
  // rent and booking
  rentAndBooking: "Аренда и бронирование",
  apartments: "Апартаменты",
  houseRental: "Аренда жилья",
  boutiqueHotel: "Бутик отель",
  guesthouse: "Гестхаус",
  resortHotel: "Курортный отель",
  motel: "Мотель",
  hotels: "Отели",
  sanatorium: "Санаторий",
  hostel: "Хостел",
  // tourism
  tourismOfHakasia: "Туризм в Хакасии",
  excursionsOfHakasia: "Экскурсии в Хакасии",
  nutritionOfHakasia: "Питание в Хакасии",
  trasportOfHakasia: "Транспорт в Хакасии",
};
